// Combat background manifest — 7 hand-picked images served from
// /cve/backgrounds/. Selection is deterministic per match seed so a
// player who refreshes mid-combat sees the same scene.
//
// The actual Sprite is loaded + composited in CombatCanvas; this file
// just owns the URL list + the deterministic picker.

const FILES = [
  'a_chicano_barrio_back_alley_turned_into.jpeg',
  'a_neighborhood_basketball_court_with_faded_paint.jpeg',
  'a_neighborhood_basketball_court_with_faded_paint (1).jpeg',
  'a_neighborhood_basketball_court_with_faded_paint (2).jpeg',
  'a_quiet_barrio_warehouse_with_large_metal.jpeg',
  'PNG 2.webp',
  'PNG 7.webp',
] as const;

export function backgroundUrlFor(seed: number): string {
  // mulberry32-style mix so adjacent seeds don't pick adjacent backgrounds.
  const mixed = (seed ^ 0x9e3779b9) >>> 0;
  const idx = mixed % FILES.length;
  return `${import.meta.env.BASE_URL}backgrounds/${encodeURIComponent(FILES[idx])}`;
}
